// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn-update[data-v-0ad663d6] {\r\n  background-color: var(--carbon-900) !important;\n}\n.btn-update[data-v-0ad663d6]:hover {\r\n  background-color: var(--carbon-800) !important;\n}\n.btn-update[data-v-0ad663d6]:pressed {\r\n  background-color: var(--black) !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
